module.exports = __webpack_public_path__ + "static/media/banner-nova-solicitacao-abastecimento.59cb06ae.jpg";